var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('BreadCrumb')], 1)]), _c('b-card', [_c('b-overlay', {
    attrs: {
      "show": _vm.showLoading,
      "rounded": "sm"
    }
  }, [_c('h4', {
    staticClass: "font-weight-bold mb-4"
  }, [_vm._v("會員合併")]), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "m",
      "label": "欲取代的 UID"
    }
  }, [_c('b-form-input', {
    attrs: {
      "disabled": _vm.outerQueryIsDone
    },
    model: {
      value: _vm.fromOuterCode,
      callback: function callback($$v) {
        _vm.fromOuterCode = $$v;
      },
      expression: "fromOuterCode"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "m",
      "label": "新的 UID"
    }
  }, [_c('b-form-input', {
    attrs: {
      "disabled": _vm.outerQueryIsDone
    },
    model: {
      value: _vm.toOuterCode,
      callback: function callback($$v) {
        _vm.toOuterCode = $$v;
      },
      expression: "toOuterCode"
    }
  })], 1), _c('div', {
    staticClass: "d-flex justify-content-center"
  }, [_c('b-button', {
    attrs: {
      "variant": "success",
      "disabled": _vm.outerQueryIsDone
    },
    on: {
      "click": _vm.handleQueryIsClicked
    }
  }, [[_vm._v("查詢")]], 2), _c('b-button', {
    staticClass: "ml-3",
    attrs: {
      "variant": "success",
      "disabled": !_vm.fromOuterCode && !_vm.toOuterCode
    },
    on: {
      "click": _vm.handleCleanIsClicked
    }
  }, [[_vm._v("清除")]], 2)], 1), _vm.outerQueryIsDone ? [_c('h5', {
    staticClass: "font-weight-bold mt-4"
  }, [_vm._v("欲取代的會員資料(此區 UID 將被更新)")]), _c('b-table', {
    attrs: {
      "striped": "",
      "hover": "",
      "items": _vm.fromCustomers,
      "fields": _vm.customerFields
    },
    scopedSlots: _vm._u([{
      key: "cell(merchant)",
      fn: function fn(data) {
        return [_c('span', {
          staticClass: "badge badge-primary text-wrap"
        }, [_vm._v(_vm._s(data.item.merchant.name))])];
      }
    }], null, false, 2640738847)
  }), _c('h5', {
    staticClass: "font-weight-bold mt-4"
  }, [_vm._v("新的會員資料(此區資料將被刪除)")]), _c('b-table', {
    attrs: {
      "striped": "",
      "hover": "",
      "items": _vm.toCustomers,
      "fields": _vm.customerFields
    },
    scopedSlots: _vm._u([{
      key: "cell(merchant)",
      fn: function fn(data) {
        return [_c('span', {
          staticClass: "badge badge-primary text-wrap"
        }, [_vm._v(_vm._s(data.item.merchant.name))])];
      }
    }], null, false, 2640738847)
  }), _c('div', {
    staticClass: "d-flex justify-content-center mt-4"
  }, [_c('b-button', {
    attrs: {
      "variant": "success",
      "disabled": _vm.outerCodesAreInvalid
    },
    on: {
      "click": _vm.handleMergeIsClicked
    }
  }, [[_vm._v("確認取代")]], 2)], 1)] : _vm._e()], 2)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }